
import {Component, Emit, Prop, Vue} from "vue-property-decorator";
import {MdbsCore} from "@/api/tsclient";
import IQueryShortDto = MdbsCore.IQueryShortDto;
import {QueryStage} from "@/components/query/QueryStates";

@Component({
  name: 'QueryAnswerMenuItem',
  components: {},
})
export default class QueryAnswerMenuItem extends Vue {

  @Prop({required: true})
  private query: IQueryShortDto;

  get iconColor() {
    let color = "success";

    if (this.query.stageState == QueryStage.OPEN) {
      if (this.query.lastComment?.creatingUserRoleIdentifier == "Physician" ||
          this.query.lastComment?.creatingUserRoleIdentifier == "Nurse")
        color = "info";
      else
        color = "error"
    }
    if (this.query.stageState == QueryStage.PENDING) {
      color = "secondary";
    }
    if (this.query.stageState == QueryStage.INVISIBLE || this.query.stageState == QueryStage.NO_LONGER_RELEVANT) {
      color = "grey";
    }
    return color;
  }

  @Emit("onOpenQuery")
  onOpenQuery() {
    return this.query;
  }

}
